/* eslint-disable react/no-danger */
import { CircularProgress } from '@mui/material'
import React, { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useReactToPrint } from 'react-to-print'
import { selectDanfeState } from './danfeSelector'
import { actions } from './danfeState'
import { InvoiceTypes } from './danfeTypes'
import { CustomPrintButton, DanfeContainer, LoaderWeapper } from './styles'

interface DanfeParams{
  invoiceKey: string
  type: InvoiceTypes
  allowPrinting?: boolean
  onError?: () => void
}

export const Danfe: React.FC<DanfeParams> = ({
  invoiceKey, type, allowPrinting = false, onError,
}) => {
  const dispatch = useDispatch()
  const danfeState = useSelector(selectDanfeState)
  const danfe = useRef(null)

  useEffect(() => {
    dispatch(actions.getInvoice({ invoiceKey, type, onError }))
  }, [dispatch, invoiceKey, type, onError])

  const print = useReactToPrint({
    content: () => danfe.current,
    copyStyles: false,
  })

  if (danfeState.loading) {
    return (
      <LoaderWeapper>
        <CircularProgress/>
      </LoaderWeapper>
    )
  }

  return (
    <DanfeContainer allowPrinting={allowPrinting}>
      <div ref={danfe} dangerouslySetInnerHTML={{ __html: danfeState.invoiceHtml }}/>
      {
        allowPrinting && (
        <CustomPrintButton onClick={print} style={{ marginTop: '16px' }}>
          Imprimir
        </CustomPrintButton>
        )
      }
    </DanfeContainer>
  )
}
